export default function formatPrice(price, allowNegative) {
  const roundPrice = Math.round(price * 100) / 100;

  if (allowNegative) {
    return roundPrice;
  } else {
    return Math.max(roundPrice, 0);
  }
}
